<template>
	<div class="mydata">
		<div class="vx-row">

			<!-- CARD 1: CONGRATS -->
			<div class="vx-col w-full lg:w-2/5 mb-base">
				<vx-card slot="no-body" class="text-center bg-primary-gradient greet-user">
					<img src="../assets/images/elements/decore-left.png" class="decore-left" alt="Decore Left"
					     width="200">
					<img src="../assets/images/elements/decore-right.png" class="decore-right" alt="Decore Right"
					     width="175">
					<feather-icon icon="AwardIcon"
					              class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
					              svgClasses="h-8 w-8"></feather-icon>
					<el-date-picker
						style="width:50%;margin:0 25%;height: 33px;"
						class="mb-6"
						v-model="yearmonth"
						format="yyyy年MM月"
						value-format="yyyy-MM"
						placeholder="选择月份"
						type="month">
					</el-date-picker>
					<!-- <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white" style="letter-spacing: 2px;">做智慧生活的推动者,共筑百年企业梦</p> -->
					<p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">Be a promoter of smart life and build
						a century long corporate dream</p>
				</vx-card>
			</div>

			<!-- CARD 2: SUBSCRIBERS GAINED -->
			<div class="vx-col w-full sm:w-2/5 md:w-2/5 lg:w-2/5 xl:w-2/5 mb-base">
				<statistics-card-line icon="UsersIcon" :statistic="`日期:${yearmonth}`"
				                      statisticTitle="年度分数波动(以当前月为节点,往前推12个月)" ref="areaone"
				                      :chartData="analyticsData.subscribersGained" type='area'></statistics-card-line>
			</div>

			<!-- CARD 3: ORDER RECIEVED -->
			<div class="vx-col w-full sm:w-1/5 md:w-1/5 lg:w-1/5 xl:w-1/5 mb-base">
				<vx-card class="overflow-hidden">
					<div slot="no-body">
						<div class="p-6 pb-0">
							<feather-icon icon="ShoppingBagIcon"
							              class="p-3 inline-flex rounded-full feather-icon select-none relative text-warning mb-4"
							              style="background: rgba(var(--vs-warning),0.15);"></feather-icon>
							<div class="line-area-chart linedata" style="height: 150px;padding-bottom: 10%;">
								<!-- <h3 class="mb-1 font-bold">{{grade}}</h3>
								<span>222</span> -->
								<div><p>本月</p>
									<p>{{ linedata.thisMonth }}</p></div>
								<div><p>上月</p>
									<p>{{ linedata.firstMonth }}</p></div>
								<div><p>环比(%)</p>
									<p :style="linedata.growthValue>0?'color: rgb(63, 134, 0)':'color: rgb(207, 19, 34)'">
										{{ linedata.chainRatio }}
										<feather-icon :icon=" linedata.chainRatio < 0 ? 'ArrowDownIcon' : 'ArrowUpIcon'"
										              :svgClasses="[linedata.chainRatio < 0 ? 'text-danger' : 'text-success'  ,'stroke-current h-4 w-4 mb-1 mr-1']"></feather-icon>
									</p>
								</div>
								<div><p>增长值</p>
									<p :style="linedata.growthValue>0?'color: rgb(63, 134, 0)':'color: rgb(207, 19, 34)'">
										{{ linedata.growthValue }}
										<feather-icon
											:icon=" linedata.growthValue < 0 ? 'ArrowDownIcon' : 'ArrowUpIcon'"
											:svgClasses="[linedata.growthValue < 0 ? 'text-danger' : 'text-success'  ,'stroke-current h-4 w-4 mb-1 mr-1']"></feather-icon>
									</p>
								</div>
							</div>
						</div>

					</div>
				</vx-card>
			</div>
		</div>
		<div class="vx-row">

			<div class="vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base">
				<vx-card title="四大分类" style="min-height: 400px;">
					<div v-for="(browser, index) in analyticsData.browserAnalytics" :key="browser.id"
					     :class="{'mt-4': index}">
						<div class="flex justify-between">
							<div class="flex flex-col">
								<span class="mb-1">{{ browser.name }}</span>
								<h4>{{ browser.ratio }}%</h4>
							</div>
							<div class="flex flex-col text-right">
		                        <span class="flex -mr-1">
		                            <span class="mr-1">{{ browser.comparedResult }}</span>
		                            <feather-icon :icon=" browser.comparedResult < 0 ? 'ArrowDownIcon' : 'ArrowUpIcon'"
		                                          :svgClasses="[browser.comparedResult < 0 ? 'text-danger' : 'text-success'  ,'stroke-current h-4 w-4 mb-1 mr-1']"></feather-icon>
		                        </span>
								<span class="text-grey">{{ browser.thisMonth }}</span>
							</div>
						</div>
						<vs-progress :percent="browser.ratio"></vs-progress>
					</div>
				</vx-card>
			</div>

			<div class="vx-col w-full md:w-2/3 mb-base">
				<vx-card title="20项指标">
					<div class="flex">
						<span class="flex items-center"><div
							class="h-3 w-3 rounded-full mr-1 bg-primary"></div><span>上月</span></span>
						<span class="flex items-center ml-4"><div
							class="h-3 w-3 rounded-full mr-1 bg-danger"></div><span>本月</span></span>
					</div>
					<vue-apex-charts type=bar height=277 ref="demoone"
					                 :options="analyticsData.clientRetentionBar.chartOptions"
					                 :series="analyticsData.clientRetentionBar.series"/>
				</vx-card>
			</div>
		</div>
		<div class="vx-row">
			<!-- CARD 6: Product Orders -->
			<div class="vx-col w-full lg:w-1/2 mb-base">
				<vx-card title="分类占比" style="min-height: 560px;">
					<div slot="no-body">
						<!-- CHART -->
						<vue-apex-charts type=pie height=400 ref=pie class="mt-2"
						                 :options="analyticsData.customersPie.chartOptions"
						                 :series="analyticsData.customersPie.series"/>

						<!-- CHART DATA -->
						<ul class="mb-1">
							<li v-for="customerData in analyticsData.customersPie.analyticsData"
							    :key="customerData.customerType"
							    class="flex justify-between py-2 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
		                        <span class="flex items-center">
		                            <span class="inline-block h-3 w-3 rounded-full mr-2"
		                                  :style="`background:${customerData.color}`"></span>
		                            <span class="font-semibold">{{ customerData.customerType }}</span>
		                        </span>
								<span>{{ customerData.counts }}</span>
							</li>
						</ul>
					</div>

				</vx-card>
			</div>

			<!-- CARD 7: Sales Stats -->
			<div class="vx-col w-full lg:w-1/2 mb-base">
				<vx-card title="网络图" subtitle="Last 6 Months">
					<template slot="actions">
						<feather-icon icon="MoreVerticalIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
					</template>
					<div class="flex">
						<span class="flex items-center"><div
							class="h-3 w-3 rounded-full mr-1 bg-primary"></div><span>上月</span></span>
						<span class="flex items-center ml-4"><div
							class="h-3 w-3 rounded-full mr-1 bg-success"></div><span>本月</span></span>
					</div>
					<div slot="no-body-bottom">
						<vue-apex-charts type=radar height=420 ref=radar
						                 :options="analyticsData.statisticsRadar.chartOptions"
						                 :series="analyticsData.statisticsRadar.series"/>
					</div>
				</vx-card>
			</div>
		</div>
	</div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import analyticsData from './ui-elements/card/analyticsData.js'
import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue'

export default {
	data() {
		return {
			analyticsData: analyticsData,
			yearmonth: '',   //月份
			grade: 0,
			linedata: {},

		}
	},
	components: {
		VueApexCharts,
		StatisticsCardLine,
		ChangeTimeDurationDropdown
	},
	mounted() {
		this.yearmonth = this.getNowFormatDate();
	},
	watch: {
		yearmonth(newval, oldval) {
			console.log(oldval + "=>" + newval);
			this.yearmonth = newval;
			this.getmy();
		}
	},
	methods: {
		getNowFormatDate() {
			var date = new Date();
			var seperator1 = "-";
			var year = date.getFullYear();
			var month = date.getMonth() + 1;
			var strDate = date.getDate();
			if (month >= 1 && month <= 9) {
				month = "0" + month;
			}
			if (strDate >= 0 && strDate <= 9) {
				strDate = "0" + strDate;
			}
			var currentdate = year + seperator1 + month;
			var lastmonth = this.getPreMonth(currentdate)
			return lastmonth;
		},
		/**
		 * 获取上一个月
		 * @date 格式为yyyy-mm-dd的日期，如：2014-01
		 */
		getPreMonth(date) {
			var arr = date.split('-');
			var year = arr[0]; //获取当前日期的年份
			var month = arr[1]; //获取当前日期的月份
			var days = new Date(year, month, 0);
			days = days.getDate(); //获取当前日期中月的天数
			var year2 = year;
			var month2 = parseInt(month) - 1;
			if (month2 == 0) {
				year2 = parseInt(year2) - 1;
				month2 = 12;
			}
			if (month2 < 10) {
				month2 = '0' + month2;
			}
			var t2 = year2 + '-' + month2;
			return t2;
		},
		getmy() {
			const that = this;
			this.$api.mydata({assessTime: that.yearmonth}).then(function (response) {
				if (response.code == 0) {
					console.log("统计数据:", response.data);
					that.linedata.thisMonth = response.data.thisMonth;
					that.linedata.firstMonth = response.data.firstMonth;
					that.linedata.chainRatio = response.data.chainRatio;
					that.linedata.growthValue = response.data.growthValue;

					let bo = [];
					response.data.monthToMonthComparison.forEach(item => {
						bo.push(item.avgScore);
					})
					var str = `本月:${response.data.monthToMonthComparison[response.data.monthToMonthComparison.length - 1].avgScore}  上月:${response.data.monthToMonthComparison[response.data.monthToMonthComparison.length - 2].avgScore}`
					that.grade = str || 0;
					that.$refs.areaone.chartData.series = [{name: '分数', data: bo}];
					//四大类
					that.analyticsData.browserAnalytics = response.data.fourItems.map((item, index) => {
						item.id = index + 1;
						item.name = item.dimension;
						item.ratio = Number(((item.thisMonth / 25) * 100).toFixed(2));
						item.comparedResult = item.growthValue;
						return item;
					});

					//20项指标
					var name = [];
					var thisMonth = [];
					var firstMonth = [];
					response.data._20Comparisons.forEach(item => {
						name.push(item.behaviors);
						thisMonth.push(item.thisMonth);
						firstMonth.push(item.firstMonth);
					})
					that.$refs.demoone.updateOptions({
						series: [{name: '上月', data: firstMonth}, {name: '本月', data: thisMonth,}],
						xaxis: {categories: name}
					})
					//扇形图
					let namearr = [];
					let dataarr = [];
					let lastarr = [];
					let objarr = [];
					let colorarr = ['#7961F9', '#FF9F43', '#EA5455', '#1CDAC9'];
					response.data.fourItems.forEach((item, index) => {
						namearr.push(item.dimension);
						lastarr.push(Number(item.firstMonth))
						dataarr.push(Number(item.thisMonth));
						let obj = {
							'customerType': item.dimension,
							'counts': Number(item.thisMonth),
							'color': colorarr[index]
						};
						objarr.push(obj);
					})
					that.analyticsData.customersPie.analyticsData = objarr;
					that.$refs.pie.updateOptions({
						series: dataarr,
						labels: namearr
					})
					//网络图
					that.$refs.radar.updateOptions({
						series: [{name: '上月', data: lastarr}, {name: '本月', data: dataarr}],
						labels: namearr
					})

				} else {
					that.$vs.notify({
						title: "提示",
						color: 'warning',
						text: response.message,
						position: 'top-center'
					});
				}
			})
		}
	}
}
</script>
<style lang="scss">
.mydata .linedata {
	display: flex;
	flex-wrap: wrap;
}

.mydata .linedata > div {
	width: 50%;
	height: 50px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: flex-start;
}

.mydata .linedata > div p:nth-of-type(2) {
	color: #000000d9;
	font-size: 20px;
	font-weight: 600;
}

.mydata .el-input--prefix .el-input__inner {
	background: none;
	color: #FFFFFF;
}

.mydata {
	.greet-user {
		position: relative;

		.decore-left {
			position: absolute;
			left: 0;
			top: 0;
		}

		.decore-right {
			position: absolute;
			right: 0;
			top: 0;
		}
	}

	@media(max-width: 576px) {
		.decore-left, .decore-right {
			width: 140px;
		}
	}
}
</style>
